import { render, staticRenderFns } from "./PromoPageModals.vue?vue&type=template&id=1866976e&"
import script from "./PromoPageModals.vue?vue&type=script&lang=ts&"
export * from "./PromoPageModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports